
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/how-it-works",
      function () {
        return require("private-next-pages/sub/how-it-works.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/how-it-works"])
      });
    }
  